var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-576 -216)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 6,
    transform: "translate(576 216)",
    fill: "#e5e5ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.669,4.344a3.709,3.709,0,0,1,5.245,5.245l-17.7,17.7L3,29.257l1.967-7.212Z",
    transform: "translate(590 229.743)",
    fill: "none",
    stroke: "#171a20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.84718c7e.svg";
export { ForwardRef as ReactComponent };